import { FeatureFlag } from '../FeatureFlag';

export const enableAdminTradingOrderManagementDebug = new FeatureFlag({
    key: 'enable-admin-trading-order-management-debug',
    createdOn: '2025-04-25',
    defaultValue: false,
});
